import { render, staticRenderFns } from "./BotCreate.vue?vue&type=template&id=80da6c10&"
import script from "./BotCreate.vue?vue&type=script&lang=js&"
export * from "./BotCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports